import axios from "../../../api/axiosConfig";
import { SET_CALENDAR_COLORS } from "../../reducers/CalendarColorReducer/calendarColorReducer";
import { getItem, setItem } from "../../../utils/storageHelper";

export const getCalendarColors = () => async (dispatch) => {
    try {
        const response = await axios.get(
            `${import.meta.env.VITE_PUBLIC_DOMAIN}User/getCalendarColors`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (response.status === 200 && response.data) {

            const calendarSettings = await getItem(`userCalendarSettings:${import.meta.env.VITE_PUBLIC_APP_ENV}`);
            let settings = JSON.parse(calendarSettings);
            settings.colors = response.data;
            await setItem(
                `userCalendarSettings:${import.meta.env.VITE_PUBLIC_APP_ENV}`,
                JSON.stringify(settings)
            );

            dispatch({
                type: SET_CALENDAR_COLORS,
                payload: response.data
            });
        }
    } catch (error) {
        console.error('Error fetching calendar colors:', error);
    }
};